import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  fileUploadingSubject = new BehaviorSubject({});
  constructor(private http: HttpClient) {}

  postFile(file: any, type: string): Observable<any> {
    this.fileUploadingSubject.next({ type, loading: true });
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.http.post(`${SETTINGS.BASE_API}/files/upload`, formData);
  }
}
